import { c as create_ssr_component, v as validate_component } from "../../../chunks/ssr.js";
import { M as Modal, C as ContactSubmission } from "../../../chunks/Modal.js";
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: ".wrapper.svelte-skgcnb.svelte-skgcnb{display:flex;flex-direction:column}.wrapper.svelte-skgcnb .header.svelte-skgcnb{display:flex;gap:2rem;padding:5rem}@media(max-width: 800px){.wrapper.svelte-skgcnb .header.svelte-skgcnb{flex-direction:column;padding-bottom:0px}}.contact.svelte-skgcnb.svelte-skgcnb{padding:10rem 5rem;background-color:#f9f7f3}@media screen and (max-width: 1024px){.contact.svelte-skgcnb.svelte-skgcnb{padding:5rem 2.5rem}}.title.svelte-skgcnb.svelte-skgcnb{font-family:'REM Variable';font-size:8rem;font-weight:700;text-transform:uppercase}@media screen and (max-width: 1024px){.title.svelte-skgcnb.svelte-skgcnb{font-size:6.5rem}}@media screen and (max-width: 768px){.title.svelte-skgcnb.svelte-skgcnb{font-size:5rem;text-align:center}}.title.svelte-skgcnb span.svelte-skgcnb{display:inline-block}.title--blue.svelte-skgcnb.svelte-skgcnb{background-color:#0e76bc;padding:0 2rem}",
  map: null
};
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let showModal = false;
  $$result.css.add(css);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1vse4nj_START -->${$$result.title = `<title>Financing | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation financing application"><!-- HEAD_svelte-1vse4nj_END -->`, ""} ${validate_component(Modal, "Modal").$$render(
      $$result,
      { showModal },
      {
        showModal: ($$value) => {
          showModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} <div class="wrapper svelte-skgcnb"><div class="header svelte-skgcnb" data-svelte-h="svelte-vwlrvl"><h1 class="title svelte-skgcnb"><span class="title--blue svelte-skgcnb">Financing</span></h1></div> <div class="contact svelte-skgcnb">${validate_component(ContactSubmission, "ContactSubmission").$$render(
      $$result,
      { financing: true, showModal },
      {
        showModal: ($$value) => {
          showModal = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div> </div>`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
